export default __webpack_public_path__ + "static/media/blurred-bg_mobile.6bfd1195.png";